import { createGenericSlice, GenericState } from 'stores/generics'
import {
  STORE_INVOICE_ATTACH_FILE,
  STORE_STATUS_FINISHED,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { PayloadAction } from '@reduxjs/toolkit'

type AttachInvoiceFileState = File | null

type State = GenericState<AttachInvoiceFileState>

export const initialState: State = {
  data: null,
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

const userSlice = createGenericSlice({
  name: STORE_INVOICE_ATTACH_FILE,
  initialState,
  reducers: {
    attachInvoiceFile: (state, action: PayloadAction<File | null>) => {
      return {
        ...state,
        data: action.payload,
        status: STORE_STATUS_FINISHED,
      }
    },
  },
})

const { actions, reducer } = userSlice

const { clear, attachInvoiceFile } = actions

export { clear, attachInvoiceFile }

export default reducer
